"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    card: {
      height: '100%',
      cursor: 'pointer',
      '&:hover, &:focus': {
        boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)'
      },
      borderRadius: 0,
      boxShadow: 'none'
    },
    noCta: {
      cursor: 'default',
      '&:hover, &:focus': {
        boxShadow: 'none'
      }
    },
    title: {
      fontSize: '2.13rem',
      margin: 0,
      marginBottom: '2rem'
    },
    subtitle: {
      fontSize: '.8rem',
      marginBottom: '.5rem',
      display: 'block'
    },
    cardTitle: {
      fontSize: '1.2rem',
      fontWeight: 'bold',
      marginBottom: '1rem'
    },
    ul: {
      listStyleType: 'none',
      padding: 0
    },
    li: function li(_ref) {
      var fill = _ref.fill;
      return {
        flexGrow: fill ? 1 : 0,
        maxWidth: fill ? '100%' : 'auto'
      };
    }
  };
});
var _default = useStyles;
exports["default"] = _default;